<template lang="pug">
  div.tutorial(v-if="show")
    transition(name="fade")
      div.tuto-intro(v-if="step === 0")
        div.btns.btn-start(@click="setStep(1)") 시작하기
        div.tuto-check
          div.tuto-check-input
            input#tuto-ch(type="checkbox", v-model="dontShow")
          label(for="tuto-ch") 다시보지 않기
        div.tuto-end(@click="close")
    transition(name="fade")
      div.tuto-container.tuto-step01(v-if="step === 1")
        div.tuto-wrap
          div.btn-tuto-off(@click="close")
          h1.tuto-header 깔끔하고 세련된 사용자화면(UI)
          p.tuto-header
            | 변화된 디자인 컨셉에 맞추어 더 시원한 여백과 깔끔한 형태로 웹매니저를 정비하였으며
            br
            | 주요 메뉴의 배치 또한 변경되었습니다.
          div.tuto-content
            div.tuto-01-img-01
              img(src="@/assets/tutorial/img-tuto-01.png")
            div.tuto-01-img-02(:class="{show: tip1}")
              img(src="@/assets/tutorial/img-tuto-02.png")
            div.tuto-01-tip(@click="setTip(1)") 장치 삭제 버튼이 어디 갔지?
          div.tuto-footer
            div.tuto-next
              | 여러 장치를 편집하고 싶다면?
              button.btn-tuto-next.tuto-01-next(@click="setStep(2)") NEXT
            div(style="clear:both;")
    transition(name="fade")
      div.tuto-container.tuto-step02(v-if="step === 2")
        div.tuto-wrap
          div.btn-tuto-off(@click="close")
          h1.tuto-header 다양한 관리 편의 기능 추가
          p.tuto-header &nbsp;
          div.tuto-content
            div.tuto-02-img-01
              | 1. 다수의 장치를 편집하기 위한 ‘편집모드‘
              img(src="@/assets/tutorial/img-tuto02-01.png")
            div.tuto-02-img-02
              | 2. ‘Drag&amp;Drop’으로 장치/그룹 이동
              img(src="@/assets/tutorial/img-tuto02-02.gif")
            div(style="clear:both;")
          div.tuto-footer
            div.tuto-next
              | 꺼진 PC를 키고 싶다면?
              button.btn-tuto-next.tuto-02-next(@click="setStep(3)") NEXT
            div(style="clear:both;")
    transition(name="fade")
      div.tuto-container.tuto-step03(v-if="step === 3")
        div.tuto-wrap
          div.btn-tuto-off(@click="close")
          h1.tuto-header 다양한 관리 편의 기능 추가
          p.tuto-header &nbsp;
          div.tuto-content
            div.tuto-03-img-01
              | 3. 꺼진 PC 전원을 켜는 WOL(Wake-On-Lane) 기능
              img(src="@/assets/tutorial/img-tuto03-01.png")
              span * 해당 기능은 Corporate용이며, 사용하기 위한 PC설정이 필요합니다.
              div.tuto-03-tip(@click="setTip(3)")
              div.tuto-03-img-01-01(:class="{show: tip3}")
            div.tuto-03-img-02
              | 4. 자주 보는 장치 즐겨찾기
              img(src="@/assets/tutorial/img-tuto03-02.png")
            div(style="clear:both;")
          div.tuto-footer
            div.tuto-next
              | 궁금한걸 물어보고 싶다면?
              button.btn-tuto-next.tuto-03-next(@click="setStep(4)") NEXT
            div(style="clear:both;")
    transition(name="fade")
      div.tuto-container.tuto-step04(v-if="step === 4")
        div.tuto-wrap
          div.btn-tuto-off(@click="close")
          div.tuto-04-img
</template>

<script>
import store from '@/api/store'
export default {
  name: 'Tutorial',
  methods: {
    setStep (n) {
      this.step = n
    },
    setTip (n) {
      this[`tip${n}`] = !this[`tip${n}`]
    },
    close () {
      if (this.dontShow) {
        store.set('tutorial_v2_0', true)
      }
      this.show = false
    }
  },
  created () {
    const flag = store.get('tutorial_v2_0')
    if (!flag) {
      this.show = true
      this.$log.info('[TUTORIAL CREATED]')
    }

    this.AppState.$on('open-tutorial', () => {
      this.show = true
    })
  },
  data () {
    return {
      show: false,
      step: 0,
      dontShow: false,
      tip1: false,
      tip3: false
    }
  }
}
</script>

<style lang="scss" scoped>
.tutorial {
  position:fixed;
  min-width:100%; min-height:100%;
  width:100%; height:100%;
  top:0; left:0;
  background-color:rgba(0,0,0,0.7);
  overflow:hidden;
  z-index: 9999999;

  .btns { cursor:pointer; }

  .tuto-intro {
    position:absolute;
    top:50%; left:50%;
    width:1280px; height:684px;
    margin-top:-342px; margin-left:-640px;
    background-image:url('../../../assets/tutorial/intro-bg.png');
    background-repeat:no-repeat;
    background-size:1280px 684px;
    background-position:center center;
  }

  .btn-start {
    position:absolute;
    bottom:0px; left:50%;
    width:240px; height:72px;
    margin-left:-120px;
    background-color:#4fddc5;
    border-radius:4px;
    color:#fff;
    text-align:center;
    font-size:24px;
    line-height:72px;
    box-shadow:0px 1px 0px rgba(0,0,0,1);
  }
  .tuto-end {
    position:absolute;
    width:40px; height:40px;
    cursor:pointer; top:0; right:160px;
    z-index:3;
    background-image:url('../../../assets/tutorial/img-tuto-end.png');
    background-repeat:no-repeat;
    background-size:40px 40px;
    background-position:center center;
  }
  .tuto-check {
    position:absolute;
    height:40px;
    top:0; right:200px;
    z-index:3;
    text-align:right;
    font-size:14px;
    color:#fff;
    line-height:40px;
    label{ cursor:pointer; }
  }
  .tuto-check-input {
    position:absolute;
    width:16px; height:16px;
    top:2px; right:96px;
    input {
      width:16px; height:16px;
      background-color:#fff;
      border:0;
    }
  }

  .tuto-container {
    position:absolute;
    width:960px; height:700px;
    top:50%; left:50%;
    margin-top:-350px;
    margin-left:-480px;
    background-color:#fff;
    border-radius:8px;
    box-shadow:0px 3px 3px rgba(0,0,0,0.2);
    overflow:hidden;
  }
  .tuto-wrap {
    position:relative;
    width:100%; height:100%;
    box-sizing:border-box;
    padding:24px;
  }
  .btn-tuto-off {
    position:absolute;
    width:40px; height:40px;
    top:24px; right:24px;
    z-index:99;
    cursor:pointer;
    background-image:url('../../../assets/tutorial/btn-tuto-off.png');
    background-repeat:no-repeat;
    background-position:center center;
  }

  h1.tuto-header {width:100%; text-align:center; font-size:32px; color:#000; font-weight:400; margin:0; padding:0;}
  p.tuto-header{padding-top:8px; font-size:16px; color:#666666; text-align:center; line-height:1.5em; margin:0;}
  .tuto-content{position:relative; width:912px; height:446px; margin-top:24px;}

  .tuto-footer{position:relative; width:100%; height:56px; margin-top:36px;}
  .tuto-next{float:right; width:50%; text-align:right; font-size:16px; color:#00a8ff;}
  .btn-tuto-next{width:120px; height:56px; border-radius:4px; background-color:#4fddc5; color:#fff; text-align:center; font-size:24px; cursor:pointer; border:0; font-weight:400; margin-left:16px;}
  .btn-tuto-next:hover{background-color:#00a8ff;}

  // .tuto-step01{display:none;}
  // .tuto-step02{display:none;}
  // .tuto-step03{display:none;}
  // .tuto-step04{display:none;}

  .tuto-01-tip{
    position:absolute; height:40px; bottom:16px; left:16px; border-radius:20px; background-color:#fff; z-index:3; cursor:pointer; line-height:40px; font-size:16px;  text-align:left; padding:0 16px; padding-left:48px; box-shadow:0px 3px 3px rgba(0,0,0,0.5);
    background-image:url('../../../assets/tutorial/tuto-01-tip-bg.png'); background-repeat:no-repeat; background-size:40px 40px; background-position:0px 0px;
    animation-name: tuto01tip; animation-duration:2s; animation-iteration-count: infinite; color:#000; font-weight:bold;
  }
  @keyframes tuto01tip{
    0%{left:16px;}
    50%{left:26px;}
    100%{left:16px;}
  }

  .tuto-01-tip:hover{color:#00a8ff;}

  .tuto-01-img-02{opacity: 0; transition: opacity 400ms; position:absolute; width:100%; height:100%; top:0; left:0; z-index:2;}
  .tuto-01-img-02.show { opacity: 1; }

  .tuto-02-img-01{float:left; width:640px; font-size:16px; color:#000;}
  .tuto-02-img-02{float:right; width:256px; font-size:16px; color:#000;}
  .tuto-02-img-01 img, .tuto-02-img-02 img{margin-top:16px;}

  .tuto-03-img-01{float:left; width:448px; font-size:16px; color:#000;}
  .tuto-03-img-02{float:right; width:448px; font-size:16px; color:#000;}
  .tuto-03-img-01 img, .tuto-03-img-02 img{margin-top:16px;}
  .tuto-03-img-01 span{font-size:12px;}
  .tuto-03-tip{
    position:absolute; width:64px; height:81px; z-index:2; top:270px; left:284px; cursor:pointer; animation-name: tuto03tip; animation-duration:2s; opacity:1; animation-iteration-count: infinite;
    background-image:url('../../../assets/tutorial/img-tuto03-01-tip.png'); background-repeat:no-repeat; background-position:center center;
  }
  @keyframes tuto03tip{
    0%{opacity:1;}
    50%{opacity:0;}
    100%{opacity:1;}
  }
  .tuto-03-img-01-01{
    opacity: 0; transition: opacity 400ms; position:absolute; width:558px; height:320px; top:80px; left:346px; box-shadow:0px 3px 3px rgba(0,0,0,0.2); cursor:pointer; z-index:3;
    background-image:url('../../../assets/tutorial/img-tuto03-01-01.png'); background-repeat:no-repeat; background-position:center center; background-size:100% 100%;
  }
  .tuto-03-img-01-01.show { opacity: 1; }

  .tuto-step04 {background-color:transparent;}
  .tuto-04-img {
    position:absolute; width:960px; height:700px; z-index:1; top:0; left:0;
    background-image:url('../../../assets/tutorial/img-tuto04-01.png'); background-repeat:no-repeat; background-size:100% 100%; background-position:center center;
  }

  @media (max-width:1024px) {
    display:none;
  }
}
</style>
